import { PermissionTypes } from 'enums/types';

export const defaultPermissions = [
  {
    key: 'users',
    area: 'Usuários',
    view: PermissionTypes.Blocked,
    create: PermissionTypes.Blocked,
    update: PermissionTypes.Blocked,
    disable: PermissionTypes.Blocked,
  },
  {
    key: 'routes',
    area: 'Rotas',
    view: PermissionTypes.Allow,
    create: PermissionTypes.Allow,
    update: PermissionTypes.Allow,
    disable: PermissionTypes.Allow,
  },
  {
    key: 'company',
    area: 'Empresas',
    view: PermissionTypes.Allow,
    create: PermissionTypes.Blocked,
    update: PermissionTypes.Blocked,
    disable: PermissionTypes.Blocked,
  },
  {
    key: 'drivers',
    area: 'Condutores',
    view: PermissionTypes.Allow,
    create: PermissionTypes.Allow,
    update: PermissionTypes.Allow,
    disable: PermissionTypes.Allow,
  },
  {
    key: 'projects',
    area: 'Projetos',
    view: PermissionTypes.Allow,
    create: PermissionTypes.Allow,
    update: PermissionTypes.Allow,
    disable: PermissionTypes.Allow,
  },
  {
    key: 'partners',
    area: 'Parceiros',
    view: PermissionTypes.Allow,
    create: PermissionTypes.Allow,
    update: PermissionTypes.Allow,
    disable: PermissionTypes.Allow,
  },
  {
    key: 'trainings',
    area: 'Treinamentos',
    view: PermissionTypes.Allow,
    create: PermissionTypes.Allow,
    update: PermissionTypes.Allow,
    disable: PermissionTypes.Allow,
  },
  {
    key: 'vehicles',
    area: 'Veículos',
    view: PermissionTypes.Allow,
    create: PermissionTypes.Allow,
    update: PermissionTypes.Allow,
    disable: PermissionTypes.Allow,
  },
  {
    key: 'dashboard',
    area: 'Dashboard',
    view: PermissionTypes.Allow,
    create: PermissionTypes.Blocked,
    update: PermissionTypes.Blocked,
    disable: PermissionTypes.Blocked,
  },
  {
    key: 'materials',
    area: 'Materiais',
    view: PermissionTypes.Allow,
    create: PermissionTypes.Allow,
    update: PermissionTypes.Allow,
    disable: PermissionTypes.Allow,
  },
  {
    key: 'regionals',
    area: 'Regionais',
    view: PermissionTypes.Allow,
    create: PermissionTypes.Allow,
    update: PermissionTypes.Allow,
    disable: PermissionTypes.Allow,
  },
  {
    key: 'containers',
    area: 'Embalagens',
    view: PermissionTypes.Allow,
    create: PermissionTypes.Allow,
    update: PermissionTypes.Allow,
    disable: PermissionTypes.Allow,
  },
  {
    key: 'unproductive',
    area: 'Improdutivas',
    view: PermissionTypes.Allow,
    create: PermissionTypes.Allow,
    update: PermissionTypes.Allow,
    disable: PermissionTypes.Allow,
  },
  {
    key: 'checklists',
    area: 'Checklists',
    view: PermissionTypes.Allow,
    create: PermissionTypes.Allow,
    update: PermissionTypes.Allow,
    disable: PermissionTypes.Allow,
  },
  {
    key: 'roles',
    area: 'Permissões',
    view: PermissionTypes.Allow,
    create: PermissionTypes.Allow,
    update: PermissionTypes.Allow,
    disable: PermissionTypes.Allow,
  },
];

export const columns = [
  {
    accessor: 'area',
    type: 'text',
    Header: 'AREA',
  }, {
    accessor: 'view',
    type: 'rule',
    Header: 'VER',
  }, {
    accessor: 'create',
    type: 'rule',
    Header: 'CRIAR',
  }, {
    accessor: 'update',
    type: 'rule',
    Header: 'EDITAR',
  }, {
    accessor: 'disable',
    type: 'rule',
    Header: 'ARQUIVAR',
  },
];
